export default __webpack_public_path__ + "static/media/heroBkg.15d0c4d0.png";